import client from "./client";

const masterDataApi = {
  // Get classes for school (teacher's school)
  getSchoolClasses() {
    console.log("[masterDataApi] GET /master-data/school-classes");
    return client.get("/master-data/school-classes").then((r) => {
      console.log("[masterDataApi] Classes response:", r.data);
      return r.data;
    });
  },

  // Get subjects for a class (with book grouping info)
  getSubjectsByClass(classId) {
    console.log("[masterDataApi] GET /master-data/classes/" + classId + "/subjects");
    return client
      .get(`/master-data/classes/${classId}/subjects`)
      .then((r) => {
        console.log("[masterDataApi] Subjects response:", r.data);
        return r.data;
      });
  },

  // Get chapters for a subject (grouped by book)
  // classId is required for school-specific filtering
  getChaptersBySubject(subjectId, classId) {
    const params = classId ? { params: { classId } } : {};
    console.log("[masterDataApi] GET /master-data/subjects/" + subjectId + "/chapters", params);
    return client
      .get(`/master-data/subjects/${subjectId}/chapters`, params)
      .then((r) => {
        console.log("[masterDataApi] Chapters response:", r.data);
        return r.data;
      });
  },

  // Legacy: Get all classes (admin use)
  getClasses() {
    return client.get("/master-data/classes").then((r) => r.data);
  },

  // Legacy: Get full hierarchy (classes → subjects → chapters)
  getHierarchy() {
    return client.get("/master-data/hierarchy").then((r) => r.data);
  },
};

export default masterDataApi;
